import React, { useMemo } from 'react';
import styled from 'styled-components';
import ReactSVG from 'react-svg';

import * as variables from 'styles/variables';
import HeaderOptions from 'components/Styled/Header/Options';
import { useReportFiles } from 'hooks/useReport';
import FileLabel from './FileLabel';
import { IconBorder, Content } from '../Header.styles';

const Counter = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 2;
	background: white;
	font-size: 10px;
	position: absolute;
	bottom: -3px;
	right: -5px;
	border-radius: 4px;
	border: 2px solid ${variables.primaryColors.secondary};
	min-width: 10px;
`;

const FilesDownload = () => {
	const {
		pendingFiles,
		options,
		deleteReportFile,
		cancelReportFile,
	} = useReportFiles();

	const _options = useMemo(() => {
		return options?.map(({ data }) => ({
			label: FileLabel,
			data,
			onDelete: deleteReportFile,
			onCancel: cancelReportFile,
		})) || [];
	}, [cancelReportFile, deleteReportFile, options]);

	return (
		<Content>
			<HeaderOptions options={_options}>
				<IconBorder $isLoading={pendingFiles}>
					<ReactSVG src="/data/svg/download-cloud.svg" />

					{!!pendingFiles && (
						<Counter>{pendingFiles}</Counter>
					)}
				</IconBorder>
			</HeaderOptions>
		</Content>
	);
};

export default FilesDownload;
